"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.help = exports.loadProduct = void 0;
const vue_1 = __importDefault(require("vue"));
const http = () => {
    return vue_1.default.prototype.$http;
};
// 请求首页的轮播图
exports.loadProduct = (params) => http().post('/home/index', params);
// 建议咨询
exports.help = (params) => http().post('/consultRec/insert', params);
